// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: 'Arial', sans-serif;
}

.login-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  padding: 40px;
  width: 100%;
  max-width: 420px;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h1 {
  color: #333;
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: 600;
}

.login-header p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.login-input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.login-input:focus {
  outline: none;
  border-color: #667eea;
}

.remember-me-container {
  display: flex;
  align-items: center;
  margin: 5px 0;
}

.remember-me-container label {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.remember-me-container input[type="checkbox"] {
  margin-right: 8px;
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.remember-me-text {
  color: #666;
  font-size: 14px;
}

.login-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

.login-btn,
.signup-btn,
.guest-btn,
.switch-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.login-btn {
  background: #667eea;
  color: white;
}

.login-btn:hover {
  background: #5568d3;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.signup-btn {
  background: #764ba2;
  color: white;
}

.signup-btn:hover {
  background: #663d8f;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(118, 75, 162, 0.4);
}

.guest-btn {
  background: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
}

.guest-btn:hover {
  background: #e0e0e0;
  transform: translateY(-1px);
}

.switch-btn {
  background: transparent;
  color: #667eea;
  border: 1px solid #667eea;
  font-size: 13px;
  padding: 10px;
}

.switch-btn:hover {
  background: #f5f7ff;
  transform: translateY(-1px);
}

.error-message {
  color: #e74c3c;
  font-size: 14px;
  margin: 5px 0 0 0;
  text-align: center;
  padding: 10px;
  background: #fef5f5;
  border-radius: 6px;
  border: 1px solid #fcc;
}
`, "",{"version":3,"sources":["webpack://./src/css/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":[".login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  font-family: 'Arial', sans-serif;\n}\n\n.login-container {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  padding: 40px;\n  width: 100%;\n  max-width: 420px;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.login-header h1 {\n  color: #333;\n  font-size: 24px;\n  margin-bottom: 10px;\n  font-weight: 600;\n}\n\n.login-header p {\n  color: #666;\n  font-size: 14px;\n  margin: 0;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.login-input {\n  width: 100%;\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.3s;\n  box-sizing: border-box;\n}\n\n.login-input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.remember-me-container {\n  display: flex;\n  align-items: center;\n  margin: 5px 0;\n}\n\n.remember-me-container label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n}\n\n.remember-me-container input[type=\"checkbox\"] {\n  margin-right: 8px;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n}\n\n.remember-me-text {\n  color: #666;\n  font-size: 14px;\n}\n\n.login-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.login-btn,\n.signup-btn,\n.guest-btn,\n.switch-btn {\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.login-btn {\n  background: #667eea;\n  color: white;\n}\n\n.login-btn:hover {\n  background: #5568d3;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.signup-btn {\n  background: #764ba2;\n  color: white;\n}\n\n.signup-btn:hover {\n  background: #663d8f;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(118, 75, 162, 0.4);\n}\n\n.guest-btn {\n  background: #f0f0f0;\n  color: #333;\n  border: 1px solid #ddd;\n}\n\n.guest-btn:hover {\n  background: #e0e0e0;\n  transform: translateY(-1px);\n}\n\n.switch-btn {\n  background: transparent;\n  color: #667eea;\n  border: 1px solid #667eea;\n  font-size: 13px;\n  padding: 10px;\n}\n\n.switch-btn:hover {\n  background: #f5f7ff;\n  transform: translateY(-1px);\n}\n\n.error-message {\n  color: #e74c3c;\n  font-size: 14px;\n  margin: 5px 0 0 0;\n  text-align: center;\n  padding: 10px;\n  background: #fef5f5;\n  border-radius: 6px;\n  border: 1px solid #fcc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
